<template>
  <div class="activity-sign-up-manage app-region blank-t-v blank-l-h blank-r-h">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>姓名</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入姓名" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="table.page" @change="handlePageChange"></a-table>
  </div>
</template>
<script>
  import ActivityService from '@/io/activity.js';

  export default {
    name: 'ActivitySignUpManage',
    data() {
      let self = this;
      return {
        id: this.$route.params.id,
        table: {
          loading: false,
          search: {
            name: null
          },
          page: {
            total: 0,
            current: 1,
            pageSize: 10,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal() {
              return `共${self.table.page.total}条`;
            },
          },
          data: [],
          columns: [],
        },
      };
    },
    mounted() {
      this.initInfo().then(() => {
        this.initData();
      });
    },
    methods: {
      handlePageChange(page) {
        this.table.page.current = page.current;
        this.table.page.pageSize = page.pageSize;
        this.initData();
      },
      initInfo() {
        return ActivityService.info(this.id).then(res => {
          this.table.columns = res.fields.map(val => ({
            title: val.name,
            dataIndex: `signup_data.${val.ename}`
          })).concat([
            {
              title: '报名时间',
              dataIndex: 'signup_at'
            }
          ]);
        }).catch(err => {});
      },
      searchTable() {
        this.table.page.current = 1;
        this.initData();
      },
      resetSearchTable() {
        this.table.search = {
          name: null
        };
        this.searchTable();
      },
      initData() {
        this.table.loading = true;
        ActivityService.signUpListPage(
          this.id,
          this.table.search.name,
          this.table.page.current,
          this.table.page.pageSize
        ).then(res => {
          this.table.data = res.data.map(val => {
            return val;
          });
          this.table.page.total = res.meta.pagination.total;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    }
  }
</script>

<style lang="less" scoped>

</style>